// extracted by mini-css-extract-plugin
export default {"logoWall":"Marquee_logoWall__sJ-xW","logoWrapper":"Marquee_logoWrapper__CScoy","scroll":"Marquee_scroll__4ChMX","logo":"Marquee_logo__qtxdY"};